import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Skeleton from "@material-ui/lab/Skeleton";

const useStyles = makeStyles((theme) => ({
  root: { marginLeft: theme.spacing(1.25), marginRight: theme.spacing(1.25) },
  name: { marginTop: theme.spacing(0.5), marginBottom: theme.spacing(3) },
}));

export default function StagePlaceHolder() {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Skeleton className={classes.name} />
      <Skeleton />
      <Skeleton />
    </div>
  );
}
